import { Grid, styled } from "@mui/material";
import React, { useState } from "react";
import useAuth from "../../hooks/useAuth";
import "react-datepicker/dist/react-datepicker.css";
import MaterialOutwardComponent from "../../components/Dashboard/MaterialOutwardComponent";
import MaterialReturnableComponent from "../../components/Dashboard/MaterialReturnableComponent";
import ReportsDownload from "./ReportsDownload";
import CustomDivider from "../../components/Components/CustomDivider"

const Card = styled(Grid)`
  border: 1px solid #000;
  border-radius: 15px;
  padding: 34px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  // box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.12);
  box-shadow: 1px 1px rgba(16, 24, 40, 0.12);
`;

function Reports({ setModelToggle }) {
  const [stepper, setStepper] = useState("REPORTS");
  const [module, setModule] = useState("");
  const { auth } = useAuth();

  const adminRoles = ["superadmin", "ERP MANAGER"];
  const guestRoles = [
    "superadmin",
    "ERP MANAGER",
    "VEHICLE INCHARGE",
    "HR MANAGER",
    "FINANCE_MANAGER",
    "ELECTRICAL_MANAGER",
    "MECHANICAL_MANAGER",
    "ACCOUNTS_MANAGER",
    "STORE_MANAGER",
  ];
  const milkRoles = ["superadmin", "ERP MANAGER", "CANTEEN INCHARGE"];
  const vechileRoles = [
    "superadmin",
    "ERP MANAGER",
    // "HR MANAGER",
    "VEHICLE INCHARGE",
  ];
  const materialInward = [
    "superadmin",
    "ERP MANAGER",
    "STORE KEEPER",
    "CANTEEN INCHARGE",
    "DESPATCH INCHARGE",
    "FACTORY MANAGER",
    "PRODUCTION MANAGER",
    "DGM",
    "PURCHASE MANAGER",
    "RAW MATREIAL INCHARGE",
    "CANTEEN INCHARGE",

  ];
  const materialOutward = [
    "superadmin",
    "ERP MANAGER",
    "STORE KEEPER",
    "MANAGING DIRECTOR",
    "DGM",
    "PURCHASE MANAGER",
    "DESPATCH MANAGER",
    "RAW MATREIAL INCHARGE",

  ];
  const materialReturnable = [
    "superadmin",
    "ERP MANAGER",
    "STORE KEEPER",
    "MANAGING DIRECTOR",
  ];

  const showMilk = milkRoles.some((val) => auth?.roles.includes(val));

  const showAdmin = adminRoles.some((val) => auth?.roles.includes(val));
  const showGuestRoles = guestRoles.some((val) => auth?.roles.includes(val));

  const showVechile = vechileRoles.some((val) => auth?.roles.includes(val));
  const showMaterialInward = materialInward.some((val) =>
    auth?.roles.includes(val)
  );
  const showMaterialOutward = materialOutward.some((val) =>
    auth?.roles.includes(val)
  );
  const showMaterialReturnale = materialReturnable.some((val) =>
    auth?.roles.includes(val)
  );

  const isManagingDirector = auth?.roles.includes("MANAGING DIRECTOR");

  console.log({ stepper }, { isManagingDirector });

  return (
    <Grid container justifyContent={"center"} xs={12} width={"100%"}>
      {stepper && stepper === "REPORTS" && (
        <Grid
          container
          columnGap={2}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={2}
          style={{ paddingBottom: '2%' }}
        >
          <Grid item container justifyContent={"center"} py={2}>
            <h4>Reports</h4>
            <CustomDivider />
          </Grid>
          {showMilk && (
            <Card
              item
              xs={3}
              onClick={() => {
                setModule("MILK");
                setStepper("REPORTS_DOWNLOAD");
              }}
            >
              Milk Reports
            </Card>
          )}

          {showGuestRoles && (
            <Card
              item
              xs={3}
              onClick={() => {
                setModule("GUESTS");
                setStepper("REPORTS_DOWNLOAD");
              }}
            >
              Guest Reports
            </Card>
          )}
          {showVechile && (
            <Card
              item
              xs={3}
              onClick={() => {
                setModule("VECHILE");
                setStepper("REPORTS_DOWNLOAD");
              }}
            >
              Vechile Reports
            </Card>
          )}
          {showMaterialInward && (
            <Card
              item
              xs={3}
              onClick={() => {
                setModule("MATERIAL_INWARD");
                setStepper("REPORTS_DOWNLOAD");
              }}
            >
              Material Inward Reports
            </Card>
          )}
          {showMaterialOutward && (
            <Card
              item
              xs={3}
              onClick={() => {
                console.log("isnindinin");
                if (isManagingDirector) {
                  console.log("inside if");
                  setStepper("MATERIAL_OUTWARD_DOWNLOAD");
                } else {
                  console.log("inside else");
                  setModule("MATERIAL_OUTWARD");
                  setStepper("REPORTS_DOWNLOAD");
                }
              }}
            >
              Material Outward Reports
            </Card>
          )}
          {showAdmin && (
            <Card
              item
              xs={3}
              onClick={() => {
                setModule("KEYS");
                setStepper("REPORTS_DOWNLOAD");
              }}
            >
              Key Reports
            </Card>
          )}
          {showMaterialReturnale && (
            <Card
              item
              xs={3}
              onClick={() => {
                if (isManagingDirector) {
                  setStepper("MATERIAL_RETURNABLE_DOWNLOAD");
                } else {
                  setModule("MATERIAL_RETURNABLE");
                  setStepper("REPORTS_DOWNLOAD");
                }
              }}
            >
              Material Returnable Reports
            </Card>
          )}
        </Grid>
      )}

      {stepper === "REPORTS_DOWNLOAD" && (
        <ReportsDownload
          setStepper={setStepper}
          module={module}
          showBack={true}
        />
      )}

      {stepper === "MATERIAL_OUTWARD_DOWNLOAD" && <MaterialOutwardComponent />}

      {stepper === "MATERIAL_RETURNABLE_DOWNLOAD" && (
        <MaterialReturnableComponent />
      )}
    </Grid>
  );
}

export default Reports;
